import type { TextareaHTMLAttributes } from 'preact';
import { cn } from '../../lib/utils';

export function Textarea({ className, ...reste }: TextareaHTMLAttributes) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-24 w-full rounded-xl border border-input bg-card px-3 py-2 text-base outline-none transition-colors',
        'placeholder:text-muted-foreground',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/25',
        'aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive/25',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'md:text-sm',
        className,
      )}
      {...reste}
    />
  );
}
